import { getAppUrl } from '@Utils/commonFunction';

export const DEFAULT_EVENT_TIME_ZONE = {
  value: 'Asia/Taipei(UTC +08:00)',
  label: 'Asia/Taipei(UTC +08:00)',
};

export const MODULE_TYPE = {
  project: 0,
  participant: 1,
  participantColumn: 2,
  badge: 3,
  healthyForm: 4,
  surveyForm: 5,
  indexPage: 6,
  email: 7,
  sms: 8,
  session: 9,
  ticketType: 10,
  ticket: 11,
  code: 15,
};

export const MODULE_ACTION_TYPE = {
  create: 0,
  update: 1,
  patch: 2,
  delete: 3,
};

/**
 *
 * @param {string} eventKey projectCode
 * @param {string} uuid 報名首頁識別碼
 * @returns {string} url
 */
export const getSignUpUrl = (eventKey, uuid) => {
  if (!eventKey || !uuid) return '';

  return `${getAppUrl()}/guest/${eventKey}/sign-up/${uuid}`;
};

export const getCustomSignUpUrl = (eventKey, uuid) => {
  if (!eventKey || !uuid) return '';

  return `${getAppUrl()}/guest/${eventKey}/custom-sign-up/${uuid}`;
};
